import { render, staticRenderFns } from "./ExportacaoAFDT.vue?vue&type=template&id=7bd5fbc0"
import script from "./ExportacaoAFDT.vue?vue&type=script&lang=js"
export * from "./ExportacaoAFDT.vue?vue&type=script&lang=js"
import style0 from "./ExportacaoAFDT.vue?vue&type=style&index=0&id=7bd5fbc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports